import { API_BASE_URL } from "../../../../config";
export async function getProvince() {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    };

    const response = await fetch(
      `${API_BASE_URL}/api/elencoProvince`,
      requestOptions
    );
    const responseData = await response.json();
    if (responseData.status !== 1) {
      console.log("Errore nel chiamare l'API delle Province");
    }
    return responseData;
  } catch (err) {
    console.log(err);
  }
}

export async function apiComuni(provinciaSigla) {
  try {
    const options = {
      method: "GET",
      headers: { accept: "application/json" },
    };
    const response = await fetch(
      `${API_BASE_URL}/api/elencoComuni/${provinciaSigla}`,
      options
    );
    const responseData = await response.json();
    if (responseData.status !== 1) {
      console.log("Errore nel chiamare l'API dei Comuni");
    }
    return responseData;
  } catch (err) {
    console.log(err);
  }
}

export async function elencoToponomie() {
  try {
    const options = {
      method: "GET",
      headers: { accept: "application/json" },
    };
    const response = await fetch(
      `${API_BASE_URL}/api/elencoToponomie`,
      options
    );
    const responseData = await response.json();
    if (responseData.status !== 1) {
      console.log("Errore nel chiamare l'API delle Toponomie");
    }
    return responseData;
  } catch (err) {
    console.log(err);
  }
}

export async function getTipologiaAzienda() {
  try {
    const options = {
      method: "GET",
      headers: { accept: "application/json" },
    };
    const response = await fetch(
      `${API_BASE_URL}/api/tipoAziendaGetList`,
      options
    );
    const responseData = await response.json();
    if (responseData.status !== 1) {
      console.log("Errore nel chiamare l'API della Tipologia Azienda");
    }
    return responseData;
  } catch (err) {
    console.log(err);
  }
}
